export interface LibraryBenefitModel {
  ref: string;
  src: any;
  description: string;
}

export const libraryBenefits: LibraryBenefitModel[] = [
  {
    ref: 'friendly',
    src: () => require('@shared/assets/User_friendly_icon.svg'),
    description: 'User friendly and engaging interfaces',
  },
  {
    ref: 'categorized',
    src: () => require('@shared/assets/Content_icon.svg'),
    description: 'Content categorized by STREAM & SEL',
  },
  {
    ref: 'vastRange',
    src: () => require('@shared/assets/Activities_icon.svg'),
    description: 'Activities covering cyber safety, coding, <br> e-books, math skills, and more',
  },
  {
    ref: 'navigable',
    src: () => require('@shared/assets/Navigation_icon.svg'),
    description: 'Navigation bar always present on the screen making it easy to switch from activity to activity',
  },
  {
    ref: 'vendorsRich',
    src: () => require('@shared/assets/Content_from_icon.svg'),
    description: 'Content from 15+ vendors',
  },
  {
    ref: 'informative',
    src: () => require('@shared/assets/Index_button_icon.svg'),
    description: 'Index button showing content & descriptions categorized by subject area and age',
  },
  {
    ref: 'statistics',
    src: () => require('@shared/assets/Access_icon.svg'),
    description: 'Access to utilization statistics (by day, week, month) to show return on investment',
  },
];
